import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Col, Container, Dropdown, Form, Pagination, Row, Spinner, Table } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

// import Select from 'react-select';
import api from '../../api/api'; // Axios wrapper
import SchemeDetails from './SchemeDetails'; 
import SchemeListForm from './SchemeListForm'; 
import SchemeListTable from './SchemeListTable'; 
import Switch from '../../components/Switch';
import WatchListModal from '../../components/WatchListModal';
import DeleteConfirmationModal from '../../components/ConfirmationModal';

import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import '../custom_styles.css';
import './schemes_layout.css'; // Import the custom CSS file

// props: schemes, pageSizeDefault, topX, fundFilter, categoryFilter, etc.
export default function SchemeListNew({
  schemesProp = null, // schemesProp holds the value of schemes
  topX = null,
  filters = null,
  investOptions = [{'key' : 'Growth', 'value' : 'Growth'}],
  planOptions = [{'key' : 'Regular', 'value' : 'Regular'}],
  investPlanOptions = [{'key' : 'Growth-Regular', 'value' : 'Growth-Regular'}],
  apiURL = null,
  urlParams=null,
  schemeListTitle="Tracked Schemes",
  isAddToWatchlistApplicable=true,
  isDeleteFromWatchlistApplicable=false,
  originatorInfo=null,
}) {
  const location = useLocation();

  // Flags 
  const TOPX_CNT=20;
  const [noUserManagedSort, setNoUserManagedSort]=useState(true);

  // const isMounted = useRef(false);
  const [schemes, setSchemes] = useState(schemesProp || []);
  // const [starRatings, setStarRatings] = useState([]);
  // const [fundHouses, setFundHouses] = useState('');
  const [categories, setCategories] = useState([]);
  const catMap = new Map();
  const [selCategories, setSelCategories] = useState([]);
  // const [selectedCategories, setSelectedCategories] = useState([]);
  // const categoryOptions = [];
  const [subCategories, setSubCategories] = useState([]);
  const subCatMap = new Map();

  const [launchGroups, setLaunchGroups] = useState([]);
  const launchGroupMap = new Map();
  const [selLaunchGroups, setSelLaunchGroups] = useState([]);

  // const isFirstRender = useRef(true);
  const [loading, setLoading] = useState(!schemesProp);
  const [error, setError] = useState(null);
  // const [hoveredId, setHoveredId] = useState(null);

  // For Details
  const [selectedSchemeCode, setSelectedSchemeCode] = useState(null);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedSchemeCategory, setSelectedSchemeCategory] = useState(null);
  const [selectedSchemeType, setSelectedSchemeType] = useState(null);
  const [addToWatchListMessage, setAddToWatchListMessage] = useState("");
  const [deleteFromWatchListMessage, setDeleteFromWatchListMessage] = useState("");
  const [showDToastMsg, setShowDToastMsg] = useState(false);
  const [showToastMsg, setShowToastMsg] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [schemeListChanged, setSchemeListChanged] = useState(false);


  // const [selectedIds, setSelectedIds] = useState([]);
  // const [multiSelect, setMultiSelect] = useState(false);

  // Filter states

  const [category, setCategory] = useState('');
  const [type, setType] = useState('');
  const [investOption, setInvestOption] = useState(investOptions[0]);
  const [plan, setPlan] = useState(planOptions[0]);
  const [investPlanOption, setInvestPlanOption] = useState(investPlanOptions[0]);
  const [displayAll, setDisplayAll] = useState(false);

  // Sorting
  const [sortField, setSortField] = useState('');
  const [sortDir, setSortDir] = useState('desc');  // 'asc';
  const [searchTerm, setSearchTerm] = useState('');
  const [parentSearchTerm, setParentSearchTerm] = useState('');

  // Pagination
  const [pageSize, setPageSize] = useState(TOPX_CNT);
  const [currentPage, setCurrentPage] = useState(1);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
      Promise.all([
        api.get('/scheme-categories'),
        api.get('/scheme-types'),
        api.get('/scheme-launch-groups')
      ]).then(([cats, subCats, launch_groups]) => {
        // console.log("**************** call setCategories with ", cats);
        setCategories(cats.data);
        setSelCategories(cats.data.map(catData=>catData.scheme_category_id));
        // console.log("Set Categories ", cats.data)
        setSubCategories(subCats.data);
        // categories.map(catData => catMap.set(catData.scheme_category_id, catData.scheme_category_name)) ;
        // subCategories.map(subCatData => subCatMap.set(subCatData.scheme_type_id, subCatData.scheme_type_name));

        setLaunchGroups(launch_groups.data);
        setSelLaunchGroups(launch_groups.data.map(launch_group_data=>launch_group_data.scheme_launch_group));
        // launchGroups.map(launch_group_data => launchGroupMap.set(launch_group_data.scheme_launch_group_id, launch_group_data.scheme_launch_group));
      }).finally(() => {
        if (!schemesProp) {
          if (!isDeleteFromWatchlistApplicable) {
            if (apiURL === null) {
              apiURL = '/schemes_fbyids'
            }
            if (urlParams) {
              api.get(apiURL, {
                params: urlParams
              }).then(res => { /** console.log(res.data); **/ setSchemes(res.data)})
                .catch(err => setError('Failed to load Watchlist Schemes.'))
                .finally(() => {
                  setLoading(false);
                })
            } else {
              api.get(apiURL)
                .then(res => { /** console.log(res.data); **/ setSchemes(res.data)})
                .catch(err => setError('Failed to load schemes.'))
                .finally(() => {
                  setLoading(false);
                })
            }
          }
        } else {
          setLoading(false);
        }
    })
  }, []);

  useEffect(() => {
    if (isDeleteFromWatchlistApplicable && urlParams) {
      setLoading(true);
      api.get(apiURL, {
        params: urlParams
      }).then(res => { /** console.log(res.data); **/ setSchemes(res.data)})
        .catch(err => setError('Failed to load Watchlist Schemes.'))
        .finally(() => {
          setLoading(false);
          setSchemeListChanged(false);
        })
    }
  }, [schemeListChanged])

  useEffect(() => {
      console.log("**************** Set catMap, using ", categories);
      categories.forEach((catData, index) => {
        catMap.set(catData.scheme_category_id, catData.scheme_category_name);
      })
      console.log("**************** catMap set ", catMap)
      // setLoading(false);
    }, [categories, catMap]); 

  useEffect(() => {
      console.log("**************** Set subCatMap");
      subCategories.forEach((subCatData, index) => {
        subCatMap.set(subCatData.scheme_type_id, subCatData.scheme_type_name)
      });
      // setLoading(false);
    }, [subCategories, subCatMap]); 

  useEffect(() => {
      console.log("**************** Set launchGroupMap");
      launchGroups.forEach((launch_group_data, index) => {
        launchGroupMap.set(launch_group_data.scheme_launch_group_id, launch_group_data.scheme_launch_group)
      });
      // setLoading(false);
    }, [launchGroups, launchGroupMap]); 

  const handleCellClick= (scheme, columnName) => {
    if (selectedSchemeCode === scheme.scheme_code) {
       setSelectedScheme(null);
       setSelectedSchemeCode(null);
       setSelectedSchemeCategory(null);
       setSelectedSchemeType(null);
       setAddToWatchListMessage("");
       setDeleteFromWatchListMessage("");
       return;
    }; // Already selected
    
    setSelectedSchemeCode(scheme.scheme_code);
    setSelectedScheme(scheme);
    setAddToWatchListMessage("");
    setDeleteFromWatchListMessage("");

    //categories.map(catData => catMap.set(catData.scheme_category_id, catData.scheme_category_name)) ;
    //subCategories.map(subCatData => subCatMap.set(subCatData.scheme_type_id, subCatData.scheme_type_name));

    console.log("**** set Scheme Category Name for Scheme Details ", scheme.category, catMap);
    setSelectedSchemeCategory(catMap.get(scheme.category));
    setSelectedSchemeType(subCatMap.get(scheme.type));
  };

  const handleCloseSidebar = () => {
    setSelectedScheme(null);
    setAddToWatchListMessage("");
    setDeleteFromWatchListMessage("");
    // setShowSidebar(false);
  };

  const handleCheckboxChange = (event) => {
    const {value, checked} = event.target;
    console.log("**** handleCheckboxChange ", value, checked)
    if (checked) {
      setSelCategories((prev) => [...prev, Number(value)]);
    } else {
      if (selCategories.length === 1) {
        setShowToastMsg(true);
        return;
      }
      setSelCategories((prev) => prev.filter((item) => item !== Number(value)));
    }
  }

  const handleLaunchGroupChange = (event) => {
    const {value, checked} = event.target;
    console.log("**** handleLaunchGroupChange ", value, checked)
    if (checked) {
      setSelLaunchGroups((prev) => [...prev, value]);
    } else {
      if (selLaunchGroups.length === 1) {
        setShowToastMsg(true);
        return;
      }
      setSelLaunchGroups((prev) => prev.filter((item) => item !== value));
    }
  }

  const MyRouterURL = () => {
    const location = useLocation();
    console.log(location.pathname); // e.g., "/user/profile"
    return <div>Current Path: {location.pathname}</div>;
  }

  const processAddToWatchList = async (watchListName, addNewWatchlist) => {
    const payload = {
      watchlistName: watchListName,
      addNewWatchList: addNewWatchlist,
      selectedSchemes: [selectedScheme.id]
    };
    setAddToWatchListMessage("");
    try {
      const res = await api.post('/update-my-watchlist', payload); // JSON.stringify([selectedScheme.id]));
      if (res.status === 200) {
        setAddToWatchListMessage(res.data.message || 'Successfully Added Scheme to WatchList');
      } else if (res.status >= 400) {
        setAddToWatchListMessage(res.data.error || 'Could not add Scheme to WatchList');
      }

      return res.data
    } catch (err) {
      // setShow(true);
      setAddToWatchListMessage(err.response?.data?.message || err.response?.data?.error || 'Could not add Scheme to WatchList');
    }
  }

  const handleAddToWatchList = async e => {
    e.preventDefault();
    processAddToWatchList("MyWatchList", false)
  };

  const handleWatchListSubmit = async (data) => {
    setShowModal(false);
    processAddToWatchList(data.watchlistName, data.addNewWatchlist);
  };

  const handleDeleteFromWatchList = async (e, targetPayload) => {
    e.preventDefault();
    const payload = {
      watchlistName: targetPayload.watchlistName,
      selectedSchemes: [targetPayload.scheme_info_id]
    };
    setSelectedScheme(null);
    setSelectedSchemeCode(null);
    setSelectedSchemeCategory(null);
    setSelectedSchemeType(null);
    setAddToWatchListMessage("");
    setDeleteFromWatchListMessage("");
    setDeleteTarget(null);

    try {
      const res = await api.post('/delete-scheme-from-watchlist', payload); // JSON.stringify([selectedScheme.id]));
      if (res.status === 200) {
        setDeleteFromWatchListMessage(res.data.message || 'Successfully Deleted Scheme from WatchList');
        setSchemeListChanged(true);
      } else if (res.status >= 400) {
        setDeleteFromWatchListMessage(res.data.error || 'Scheme not deleted from WatchList');
      }
      setShowDToastMsg(true);
      return res.data
    } catch (err) {
      setDeleteFromWatchListMessage(err.response?.data?.message || err.response?.data?.error || 'Could not delete Scheme from WatchList');
      setShowDToastMsg(true);
    }
  };

  const getDeleteConfirmationMsg = (selectedSchemeName, watchlistName) => {
    return (
      <span>
        Are you sure you want to delete scheme
         <strong> {" '" + selectedSchemeName + "'" } </strong> 
        {" from '" } <i className="text-primary">{watchlistName}</i>  { "'" }
      </span>
    )
  }

  const confirmDeleteFromWatchList = ((e) => {
    const payload = {
      watchlistName: urlParams.watchlistName,
      selectedScheme: selectedScheme.name,
      scheme_info_id: selectedScheme.id
    };
    setDeleteTarget(payload);
  });

  const parentClearNameSearch = (value) => {
    // console.log("*** Inside parentClearNameSearch");

    setSearchTerm(''); // Resets the search bar state
    setParentSearchTerm('');
  }

  const parentHandleNameSearch = (value) => {
    // console.log("*** Inside parentHandleNameSearch");

    setParentSearchTerm(value);
  }

  // Filter + sort + topX
  const filtered_nonSorted = useMemo(() => {
    let data = [...schemes];
    // Optional filtering by fund
    // Other filters
    if (selCategories.length > 0) {
      data = data.filter((s) => {
        return selCategories.some(selCategory => s.category === Number(selCategory));
      });
    }
    if (selLaunchGroups.length > 0) {
      data = data.filter((s) => {
        return selLaunchGroups.some(selLaunchGroup => s.launchGroup === selLaunchGroup);
      });
    }
    if (filters && filters.fundHouses && (filters.fundHouses.length > 0)) {
      data = data.filter((s) => {
        // console.log("*** filtered, fundId ", s.fundId);
        return filters.fundHouses.some(fundHouse => s.fundId === Number(fundHouse));
      });
    }

    if (type) data = data.filter((s) => s.type === Number(type));
    if (parentSearchTerm) data = data.filter((s) => s.name.toLowerCase().includes(parentSearchTerm.toLowerCase()));

    // Top X
    if (topX && topX > 0) data = data.slice(0, topX);

    setCurrentPage(1);
    
    return data;
  }, [schemes, selCategories, selLaunchGroups, filters, type, topX, parentSearchTerm]);

  // Filter + sort + topX
  const filtered = useMemo(() => {
    let data = [...filtered_nonSorted];

    if (noUserManagedSort) {
      if (!displayAll) {
        return data.slice(0, Math.min(TOPX_CNT, data.length));
      }
      return data;
    }
    data.sort((a, b) => {
      if (sortField.length == 0) return 0; 
      let vA = a[sortField], vB = b[sortField];
      if (vA < vB) return sortDir === 'asc' ? -1 : 1;
      if (vA > vB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    if (!displayAll) {
      return data.slice(0, Math.min(TOPX_CNT, data.length));
    }
    return data;
  }, [filtered_nonSorted, sortField, sortDir, noUserManagedSort, displayAll]);

  // investOption, plan,
  // Pagination logic
  const totalPages = Math.ceil(filtered.length / pageSize);
  const pageData = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const goToPage = (num) => setCurrentPage(num);

  // Sorting handler
  const handleSort = (field) => {
    if (noUserManagedSort) {
      return;
    }
    if (sortField && (sortField === field)) setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    else { setSortField(field); setSortDir('asc'); }
  };

  const renderSimpleSort = (field) => {
    if (noUserManagedSort) {
      return  "";
    } else {
      return (sortField === field ? (sortDir === 'asc' ? '▲' : '▼') : '⇅');
    };
  };

  const getMultiSortIndicatorUpDown = (thisSortField, isASC, unitVal) => (
    <>
      {(sortField.length === 0) ? ((isASC ? '▲' : '▼') + unitVal) : ((sortField === thisSortField) ? ((sortDir === 'asc') ? '▲' : '▼') : '⇅')}
    </>
  );


  return (
    <>
      <div className="container-fluid">
        <Row>
          <Col lg={selectedScheme ? 9 : 12} md={selectedScheme ? 8 : 12} xs={12} style={{fontSize:'0.90rem'}}>
            {/* Table + Filters */}
            {loading ? (
                <div 
                  className="d-flex justify-content-center align-items-center" 
                  style={{ height: '100vh', width: '100vw' }}
                >
                  <Spinner animation="border" variant="primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
            ) : (
              <> 
                <Row className="align-items-center">
                    <Col xs={9} className="d-flex justify-content-left">
                      <h4>
                        <span class="underline">{schemeListTitle}</span>
                        <span style={{fontSize:'0.90rem'}}>:  <i>(Balanced by historical performance)</i> <b>Predicted good performers</b> are listed <b>at the top </b>and <b>in earlier pages</b>.
                        </span>
                      </h4>                      
                    </Col>
                    <Col xs={3} className="d-flex align-items-center justify-content-center">
                        <Switch
                          onColor="#fff"
                          isOn={displayAll}
                          handleToggle={() => setDisplayAll(!displayAll)}
                          lMessage={'Top '+TOPX_CNT}
                          rMessage='All'
                        />
                        <span style={{fontSize:'0.90rem'}}><b>Toggle</b> to view Top {TOPX_CNT}/ All </span>
                    </Col>
                </Row>

                <SchemeListForm 
                  selCategories={selCategories}
                  categories={categories} 
                  handleCheckboxChange={handleCheckboxChange}
                  selLaunchGroups={selLaunchGroups}
                  launchGroups={launchGroups}
                  handleLaunchGroupChange={handleLaunchGroupChange}

                  type={type} setType={(e) => setType(e)}
                  subCategories={subCategories}

                  investPlanOption={investPlanOption} setInvestOption={(e) => setInvestPlanOption(e)}
                  investPlanOptions={investPlanOptions}

                  pageSize={pageSize} setPageSize={(e) => setPageSize(e)}
                  setCurrentPage={(e) => setCurrentPage(e)}
                  parentClearNameSearch={parentClearNameSearch} parentHandleNameSearch={parentHandleNameSearch} 
                  parentSearchTerm={parentSearchTerm}
                />
                <div className="table-container" >
                  <SchemeListTable
                      handleSort={handleSort}
                      renderSimpleSort={renderSimpleSort}
                      getMultiSortIndicatorUpDown={getMultiSortIndicatorUpDown}
                      pageData={pageData}
                      handleCellClick={handleCellClick}
                      selectedScheme={selectedScheme}
                      searchTerm={parentSearchTerm}
                      isAddToWatchlistApplicable={isAddToWatchlistApplicable}
                  />
                </div>
                <Pagination className="my-2 justify-content-center">
                  {[...Array(totalPages)].map((_, i) => (
                    <Pagination.Item key={i+1} active={currentPage === i+1} onClick={() => goToPage(i+1)}>
                      {i+1}
                    </Pagination.Item>
                  ))}
                </Pagination>
                <ToastContainer position="middle-center" className="p-3">
                    <Toast onClose={() => setShowToastMsg(false)} show={showToastMsg} delay={5000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Notification</strong>
                        <small>Launch Group and Category Selection</small>
                    </Toast.Header>
                    <Toast.Body>At least One selection required, Can not uncheck all.</Toast.Body>
                    </Toast>
                </ToastContainer>
              </>
            )}
          </Col>
          {selectedScheme &&
          <Col xs={6} md={4} lg={3} className="border-start">
              <Row className="mb-2">
                  <Col xs={5} className="text-start">
                    <Link to="/schemeAlternates" state={{ baseScheme: selectedScheme, 
                                    categoryName: selectedSchemeCategory, 
                                    typeName: selectedSchemeType, routerURL: location.pathname,
                                    urlParams: urlParams,
                                    isAddToWatchlistApplicable:isAddToWatchlistApplicable,
                                    originatorInfo:originatorInfo}} >
                      <Button variant="outline-primary" className="mt-1">
                        <b>List Alternates</b>
                      </Button>
                    </Link>
                  </Col>
                  <Col xs={4} className="text-start">
                    <Link to="/compareSchemes" state={{ baseScheme: selectedScheme, 
                                    categoryName: selectedSchemeCategory,
                                    typeName: selectedSchemeType, routerURL: location.pathname,
                                    urlParams: urlParams,
                                    isAddToWatchlistApplicable:isAddToWatchlistApplicable,
                                    originatorInfo:originatorInfo}} >
                      <Button variant="outline-primary" className="mt-1">
                        <b>List Similar</b>
                      </Button>
                    </Link>
                  </Col>
                  <Col xs={3} className="text-end">
                    <Button variant="outline-secondary" onClick={handleCloseSidebar} className="mt-1">
                      Close
                    </Button>
                  </Col>
              </Row>
              <Row>
                <Col>
                    <SchemeDetails scheme={selectedScheme} categoryName={selectedSchemeCategory}
                                    typeName={selectedSchemeType} routerURL={location.pathname}/>
                </Col>  
              </Row>
              {isAddToWatchlistApplicable? 
                  (<Row>
                      <Col xs={6} className="text-start">
                          <Button variant="outline-secondary" onClick={() => setShowModal(true)} className="mt-2">
                              <b>Add to my WatchList</b>
                          </Button>
                      </Col>
                      <Col xs={6} className="text-end">
                          <span style={{fontSize:'0.90rem'}}>{addToWatchListMessage}</span>
                      </Col>
                  </Row>) : 
                (isDeleteFromWatchlistApplicable && urlParams?.watchlistName) ?
                  (
                  <>
                      <Row>
                          <Col xs={6} className="text-start">
                              <Button variant="outline-secondary" onClick={confirmDeleteFromWatchList} className="mt-2">
                                  <b>Delete from this WatchList</b>
                              </Button>
                          </Col>
                          <Col xs={6} className="text-end">
                              <span style={{fontSize:'0.90rem'}}>{deleteFromWatchListMessage}</span>
                          </Col>
                      </Row>
                      <ToastContainer position="top-center" className="p-3">
                          <Toast onClose={() => {setShowDToastMsg(false); setDeleteFromWatchListMessage("")}} show={showDToastMsg} delay={5000} autohide>
                          <Toast.Header>
                              <strong className="me-auto">Notification</strong>
                              <small>Delete Scheme from Watchlist</small>
                          </Toast.Header>
                          <Toast.Body>{deleteFromWatchListMessage}</Toast.Body>
                          </Toast>
                      </ToastContainer>
                      <DeleteConfirmationModal
                          target={deleteTarget} confirmationName={"Delete Scheme"}
                          confirmationTitle={" Scheme Delete"}
                          onConfirmFinish={() => setDeleteTarget(null)}
                          confirmHandle={handleDeleteFromWatchList}
                          confirmationQuestion={getDeleteConfirmationMsg}
                          param1={selectedScheme.name}
                          param2={urlParams.watchlistName}
                      />
                  </>
                  ) 
                  :
                  (<></>)
              }
          </Col>
          }
        </Row>
      </div>
      {isAddToWatchlistApplicable? 
        (<WatchListModal
            show={showModal}
            onHide={() => setShowModal(false)}
            newWatchlistOption={true}
            onSubmit={handleWatchListSubmit}
        />):(<></>)
      }
    </>
  );
}
